import { Pipe, PipeTransform } from '@angular/core';
@Pipe({name: 'typeOfPersonnel'})
export class TypeOfPersonnelPipe implements PipeTransform {
  transform(value: number): string {
    return value == 1 ? 'Cán bộ quản lý' :( value == 2 ? 'Giáo viên/nhân viên' : '');
  }
}